import React from 'react';
import Services from './services/services';

import { useEffect, useState } from 'react';
import logo from './logo.svg';
import './App.css';

import Product from './shop/Product';
import Cart from './shop/Cart';
import ProductDetail from './shop/ProductDetail';
import ProductList from './shop/ProductList';
import Checkout from './shop/Checkout';
import Summary from './shop/Summary';
import SummaryCash from './shop/SummaryCash';
import ProductMap from './shop/ProductMap';

import TermList from './reservations/TermList';
import PassengerList from './reservations/PassengerList';
import ReservationConfirm from './reservations/ReservationConfirm';

import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";

const App = () => {

  return (

    <div className="App">

        <Router basename="/app/">
          <Routes>

            <Route path="/product-detail/:id" element={<div><ProductDetail /></div>}/>
            // <Route path="/product-map" element={<div><ProductMap /></div>}/>
            // <Route path="/product-list" element={<ProductList />}/>
            <Route path="/cart" element={<Cart />}/>
            <Route path="/checkout" element={<Checkout />}/>
            <Route path="/summary/:id" element={<Summary />}/>
            <Route path="/summary-cash/" element={<SummaryCash />}/>
            <Route path="/:privacy" element={<ProductList />}/>
            <Route path="/" element={<ProductList />}/>

            <Route path="/term-list" element={<TermList />}/>
            <Route path="/passenger-list/:id" element={<PassengerList />}/>
            <Route path="/reservation-confirm" element={<ReservationConfirm />}/>

          </Routes>
        </Router>

    </div>

  );

}

export default App;
